import { render, staticRenderFns } from "./LibrosResult.vue?vue&type=template&id=e32cbcb6&scoped=true&"
import script from "./LibrosResult.vue?vue&type=script&lang=js&"
export * from "./LibrosResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32cbcb6",
  null
  
)

export default component.exports